import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sceneConstructorConstructedBgMenu" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  fill: "currentColor",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "m502 89c0 0 23-23 0-46l-23-22c-22-23-45 0-45 0l-113 113c0 0-23 23-45 0l-23-23c-45-45-90 0-90 0l-23 23l113 113l23 23l113 113l22-23c0 0 46-45 0-90c-9-10-16-17-22-23c-23-22 0-45 0-45z m-57-34c7-6 17-6 23 0c6 6 6 16 0 22c-6 7-16 7-23 0c-6-6-6-16 0-22z m-294 136l-22-23c-7-6-17-6-23 0l-91 90c-6 7-6 17 0 23l23 23c6 6 16 6 23 0l90-91c6-6 6-16 0-22z m68 67l-23-22c-6-6-16-6-22 0l-91 90c-6 7-6 17 0 23l23 23c6 6 16 6 23 0l90-91c6-6 6-16 0-23z m68 68l-23-22c-6-6-16-6-22 0l-91 90c-6 6-6 17 0 23l23 22c6 7 16 7 22 0l91-90c6-6 6-16 0-23z m45 46c-6-7-16-7-22 0l-91 90c-6 6-6 16 0 23l23 22c6 7 16 7 22 0l91-90c6-6 6-17 0-23z" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SceneConstructorMenuItemIcon = _resolveComponent("SceneConstructorMenuItemIcon")!
  const _component_SceneConstructorMenuItem = _resolveComponent("SceneConstructorMenuItem")!
  const _component_SceneConstructorMenu = _resolveComponent("SceneConstructorMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_SceneConstructorMenu, {
      showBackButton: true,
      showArrows: true,
      onGoBack: _cache[1] || (_cache[1] = () => _ctx.store.goTo('bgMenu'))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SceneConstructorMenuItem, {
          text: _ctx.$t('scene_constructor.create_new'),
          onClick: _cache[0] || (_cache[0] = () => _ctx.createConstructed())
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SceneConstructorMenuItemIcon, null, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["text"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.constructedBackgrounds, (background) => {
          return (_openBlock(), _createBlock(_component_SceneConstructorMenuItem, {
            key: background.id,
            onClick: () => _ctx.selectBackground(background)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SceneConstructorMenuItemIcon, {
                backgroundImage: background.photo_box_url,
                checked: _ctx.state.selectedBackground && _ctx.state.selectedBackground.id == background.id
              }, null, 8, ["backgroundImage", "checked"])
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}